<script>
  import _base from '../../_default/components/_base.vue'
  import Gmaps from './components/GoogleMap.vue'

  export default{
    name: 'Maps',
    extends: _base,
    data () {
      return {}
    },
    computed: {},
    mounted () {
//      this._menuFolded(true)
    },
    destroyed () {},
    methods: {},
    components: {Gmaps}
  }
</script>

<template>
    <div class="app-content">
        <div class="app-content-body banners">
            <Gmaps/>
          <router-view/>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Main.vue?14b3ba09